import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute } from 'appRoutes'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/integrations/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: AppRoute.IntegrationsActive, params: { subscriptionId: params.subscriptionId } })
  },
})
